import React, { useState, useEffect, useRef } from "react";
import { getExperienceProgress } from "@/utils/experience";

interface LevelGradientProgressBarProps {
  className?: string;
  exp: number;
}

export const LevelGradientProgressBar = ({
  exp,
  className,
}: LevelGradientProgressBarProps) => {
  const { level, currentExp, expToCurrentLevel, expToNextLevel, remainingExp } =
    getExperienceProgress(exp);
  const totalExpForLevel = expToNextLevel - expToCurrentLevel;
  const progressPercentage =
    totalExpForLevel > 0
      ? Math.round((remainingExp / totalExpForLevel) * 100)
      : 0;

  const [animatedProgress, setAnimatedProgress] = useState(progressPercentage); //0
  const animationFrameRef = useRef<number | null>(null);
  const animatedProgressRef = useRef(0);

  useEffect(() => {
    animatedProgressRef.current = animatedProgress;
  }, [animatedProgress]);

  useEffect(() => {
    if (animationFrameRef.current !== null) {
      cancelAnimationFrame(animationFrameRef.current);
      animationFrameRef.current = null;
    }

    const duration = 1000;
    const startTime = Date.now();
    const startProgress = animatedProgressRef.current;
    const targetProgress = progressPercentage;

    if (startProgress === targetProgress) {
      return;
    }

    /* const animate = () => {
      const elapsed = Date.now() - startTime;
      const progressRatio = Math.min(elapsed / duration, 1);

      const easeOutCubic = 1 - Math.pow(1 - progressRatio, 3);
      const currentProgress =
        startProgress + (targetProgress - startProgress) * easeOutCubic;

      setAnimatedProgress(currentProgress);
      animatedProgressRef.current = currentProgress;

      if (progressRatio < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setAnimatedProgress(targetProgress);
        animatedProgressRef.current = targetProgress;
        animationFrameRef.current = null;
      }
    }; */

    // animationFrameRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationFrameRef.current !== null) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
    };
  }, [progressPercentage]);

  const animatedPercentage = Math.round(animatedProgress);

  return (
    <div className={`w-full ${className}`}>
      <div
        className="flex relative h-10"
        style={{ width: `${Math.max(8, Math.min(animatedPercentage, 85))}%` }}
      >
        <div className="absolute top-0 right-0">
          <span className="text-[20px] text-primary-blue">
            {animatedPercentage}%
          </span>
        </div>
        <div className="absolute top-0 left-full">
          <span className="ml-3 text-[20px] text-primary-blue">
            {remainingExp}
          </span>
        </div>
      </div>
      <div className="relative w-full h-2 bg-gray-800 flex flex-start">
        <div
          className="absolute top-0 left-0 h-2 transition-all duration-1000 ease-out"
          style={{
            width: `${animatedProgress}%`,
            background: "linear-gradient(90deg, #FF6A00 0%, #0099FE 100%)",
          }}
        />
        <div
          className="absolute top-[-5px] w-[2px] h-5 bg-primary-blue transition-all duration-1000 ease-out"
          style={{ left: `${animatedProgress}%` }}
        />
      </div>
      <div className="mt-[10px] flex justify-between items-center text-primary-gray text-[16px] uppercase">
        <span>0 xp</span>
        <span>{totalExpForLevel} xp</span>
      </div>
    </div>
  );
};
